// extracted by mini-css-extract-plugin
export default {"featuresTitle":"style_featuresTitle__Xi+B4"};